import { render, staticRenderFns } from "./DiscussionText.vue?vue&type=template&id=0675f02a&scoped=true&"
import script from "./DiscussionText.vue?vue&type=script&lang=js&"
export * from "./DiscussionText.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionText.vue?vue&type=style&index=0&id=0675f02a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0675f02a",
  null
  
)

export default component.exports